<template>
    <div class="box">
        <inner-table id="innerArchive" ref="archiveList" :listviewurl="'rsgl.archiveConInfo.list'" :can-edit="canEdit" :can-delete="canEdit" :link-prop-name="'archivesId'" />
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
        }
    },
    computed: {},
    watch: {},
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        // onInnerTableListDataBeforeLoad($scope, qparams) {
        //     qparams.urlsearch = `archivesId:${this.vo?.id}`
        // },
    }
}
</script>

<style scoped>
.header {
    padding:10px 20px;
    background-color: #f2f5fb;
    font-size: 14px;
    font-weight: 500;
}
.box {
   border:1px solid #dee2e6;
}
</style>

